export const localConfig = {
    // Local Dev Configs Here
    clientId: '45g83mav0ds6fgr8c9i2inlv6i',
    baseURL: 'https://dev.ordersapi.dev.solex.com',
    loginURL: {
        base: 'https://tiro-dev.auth.us-west-2.amazoncognito.com/oauth2/authorize?',
        params: `client_id=45g83mav0ds6fgr8c9i2inlv6i&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+profile&redirect_uri=${'https://' + window.location.host + '/login/callback'}`
    },
    tokenURL: 'https://dev.ordersapi.dev.solex.com/auth/token',
    features: {
        enableRONSigningWindow: true,
        enableAddCoSettlementAgents: true
    },
    appBaseURL: `${'https://' + window.location.host + '/'}`,
    cognitoBaseURL: "https://tiro-dev.auth.us-west-2.amazoncognito.com/",
    eagleIdLogout: "https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri="
}
